import uniq from "lodash/uniq";
import { escape, addToQuery, predicate, not, concatQueryStrings, edgeClause } from "views/logic/queries/QueryHelper";
import recordQueryStringUsage from "views/logic/queries/recordQueryStringUsage";
import { updateQueryString } from "views/logic/slices/viewSlice";
import { selectQueryString } from "views/logic/slices/viewSelectors";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
import { fieldValueOrClause } from "views/logic/valueactions/ValueActionQueryHelper";
const formatNewQuery = (oldQuery, field, value) => addToQuery(oldQuery, not(predicate(field, escape(value))));
const valuesFromArray = (field, value, type) => value.map((arrayValue) => ({ field, value: arrayValue, type }));
const excludeOrClause = (oldQuery, valuePath) => {
  const orGroup = concatQueryStrings(
    valuePath.map((path) => {
      const [pathField, pathValue] = Object.entries(path)[0];
      return predicate(pathField, escape(pathValue));
    }),
    { operator: "OR", withBrackets: false }
  );
  return addToQuery(oldQuery, not(`(${orGroup})`));
};
const excludeEdgeClause = (oldQuery, valuePath) => {
  const [e0, e1] = valuePath;
  const [f0, v0] = Object.entries(e0)[0];
  const [f1, v1] = Object.entries(e1)[0];
  return addToQuery(oldQuery, not(edgeClause({ field: f0, value: v0 }, { field: f1, value: v1 })));
};
const ExcludeFromQueryHandler = ({ queryId, field, value, type, contexts }) => async (dispatch, getState) => {
  const oldQuery = selectQueryString(queryId)(getState());
  const multipleValues = hasMultipleValueForActions(contexts);
  const fieldValueIsArray = Array.isArray(value);
  const arrayValuesToExclude = fieldValueIsArray ? valuesFromArray(field, value, type) : [];
  const getValues = () => {
    if (multipleValues) return contexts.valuePath.map(() => ({ field, value, type }));
    if (fieldValueIsArray) return arrayValuesToExclude;
    return [{ field, value, type }];
  };
  const valuesToAdd = uniq(getValues());
  let newQuery;
  const shouldExcludeArrayFieldValuesWithOr = !multipleValues && arrayValuesToExclude.length > 1;
  if (multipleValues && (contexts == null ? void 0 : contexts.valuePathOperator) === "EDGE") {
    newQuery = excludeEdgeClause(oldQuery, contexts.valuePath);
  } else if (multipleValues && (contexts == null ? void 0 : contexts.valuePathOperator) === "OR") {
    newQuery = excludeOrClause(oldQuery, contexts.valuePath);
  } else if (shouldExcludeArrayFieldValuesWithOr) {
    newQuery = addToQuery(oldQuery, not(fieldValueOrClause(field, arrayValuesToExclude)));
  } else {
    newQuery = valuesToAdd.reduce(
      (prev, valueToAdd) => formatNewQuery(prev, valueToAdd.field, valueToAdd.value),
      oldQuery
    );
  }
  await recordQueryStringUsage(newQuery, oldQuery);
  return dispatch(updateQueryString(queryId, newQuery));
};
export default ExcludeFromQueryHandler;
